// extracted by css-extract-rspack-plugin
export default {"withReset":"with-reset--aM_XX1bcQI8q5Pq_"};